"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCheck = exports.CheckAliveManager = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var fetchCheck = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.ok) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", Promise.reject(new Error("".concat(url, " is not alive"))));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCheck(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchCheck = fetchCheck;

var CheckAliveManager = /*#__PURE__*/function () {
  function CheckAliveManager() {
    (0, _classCallCheck2["default"])(this, CheckAliveManager);
    (0, _defineProperty2["default"])(this, "checkAliveResultMap", new Map());
  }

  (0, _createClass2["default"])(CheckAliveManager, [{
    key: "getCheckAliveResult",
    value: function () {
      var _getCheckAliveResult = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url, ignoreCache, key, checkAlive) {
        var res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(key && checkAlive)) {
                  _context2.next = 7;
                  break;
                }

                if (!this.checkAliveResultMap.has(key) || ignoreCache) this.checkAliveResultMap.set(key, checkAlive()); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

                _context2.next = 5;
                return this.checkAliveResultMap.get(key);

              case 5:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 7:
                _context2.next = 9;
                return fetchCheck(url);

              case 9:
                return _context2.abrupt("return", true);

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", false);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function getCheckAliveResult(_x2, _x3, _x4, _x5) {
        return _getCheckAliveResult.apply(this, arguments);
      }

      return getCheckAliveResult;
    }()
  }, {
    key: "clearCheckAliveResult",
    value: function clearCheckAliveResult(key) {
      if (key) {
        this.checkAliveResultMap["delete"](key);
      } else {
        this.checkAliveResultMap.clear();
      }
    }
  }]);
  return CheckAliveManager;
}();

exports.CheckAliveManager = CheckAliveManager;